import { RecordTabLink } from '@records/records-search/records-details/records-details.controller';
import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';
import { PropertyDetailsTabId } from './action-dictionary';
import { ACTION_DEATILS_PAGE_BY_ENTITY, getPropertyMarketByUsage, getTIMMarketList } from './utils';

/*** Details Tab Actions ***/
export interface TrackClickTabAction {
  entityId: number;
  entity: EntityType;
  tabName: string;
  actionPage: string;
  entityData: TrackClickTabActionProperty | TrackClickTabActionTIM;
}

export interface TrackClickTabActionProperty {
  propertyMarket: string;
}

export interface TrackClickTabActionTIM {
  targetMarkets: string[];
}

export interface GetDataForTrackingParams {
  record: DataObject;
  selectedUsage: string;
  tab: RecordTabLink & { recordId: string };
}

const getFirstUsage = (record: DataObject) => record.usages?.[0]?.ref_property_usage_type_desc ?? '';

const getPropertyUsageMappingByTabId = {
  [PropertyDetailsTabId.Availabilities]: getFirstUsage,
  [PropertyDetailsTabId.HistoricalStats]: (record: DataObject) =>
    record.usages?.sort()[0].ref_property_usage_type_desc ?? '',
};

/**
 * Get data with the proper format for tracking the Property Entity
 * @param { record, selectedUsage }
 * @returns TrackClickTabActionProperty
 */
const getPropertyDataForTracking = ({
  record,
  selectedUsage,
  tab,
}: GetDataForTrackingParams): TrackClickTabActionProperty => {
  const usage = selectedUsage ?? getPropertyUsageMappingByTabId[tab.recordId]?.(record) ?? getFirstUsage(record);
  return { propertyMarket: getPropertyMarketByUsage(record, usage) };
};

/**
 * Get data with the proper format for tracking the TIM Entity
 * @param { record, selectedUsage }
 * @returns TrackClickTabActionProperty
 */
const getTIMDataForTracking = ({ record }: GetDataForTrackingParams): TrackClickTabActionTIM => {
  const targetMarkets = getTIMMarketList(record);
  return { targetMarkets };
};

export const DetailsTabActionEntityFormater = Object.freeze({
  [EntityType.Property]: getPropertyDataForTracking,
  [EntityType.Tim]: getTIMDataForTracking,
});
/*** Details Tab Actions ***/

/** Details Page Actions ***/
export interface RecordDetailContext {
  recordState: {
    selectedUsage: string;
    id: number;
    type: EntityType;
  };
  dataState: {
    record: DataObject;
  };
  formViewState: {
    showFavorites: boolean;
    beastMode: boolean;
  };
}

export interface TrackClickBaseActionDetailsPage {
  entityId: number;
  entity: EntityType;
  entityData: TrackClickTabActionProperty | TrackClickTabActionTIM;
  actionPage: string;
}

export interface TrackClickOnSelectUsageAction extends TrackClickBaseActionDetailsPage {
  value: string;
}

export enum TrackClickOnToggleFavoriteColumnsActionValues {
  showFavs = 'Show only favorite fields',
  showAll = 'Show all fields',
}

export interface TrackClickOnToggleFavoriteColumnsAction extends TrackClickBaseActionDetailsPage {
  value: TrackClickOnToggleFavoriteColumnsActionValues;
}

export enum TrackClickOnToggleSidePanelLocationActionValues {
  beasModeActive = 'Show widgets panel on the bottom',
  beasModeInActive = 'Show widgets panel on the Right',
}
export interface TrackClickOnToggleSidePanelLocationAction extends TrackClickBaseActionDetailsPage {
  value: TrackClickOnToggleSidePanelLocationActionValues;
}

export const getBaseActionDetailsPage = (context: RecordDetailContext) => ({
  entityId: context.recordState.id,
  entity: context.recordState.type,
  actionPage: ACTION_DEATILS_PAGE_BY_ENTITY[context.recordState.type],
});

type getDetailsActionsEntityDataByEntityTypeType = {
  [key in EntityType]?: (context) => TrackClickBaseActionDetailsPage;
};

export const getDetailsActionsEntityDataByEntityType: getDetailsActionsEntityDataByEntityTypeType = {
  [EntityType.Property]: context => ({
    ...getBaseActionDetailsPage(context),
    entityData: {
      propertyMarket: getPropertyMarketByUsage(context.dataState.record, context.recordState.selectedUsage),
    },
  }),
  [EntityType.Tim]: context => ({
    ...getBaseActionDetailsPage(context),
    entityData: {
      targetMarkets: getTIMMarketList(context.dataState.record),
    },
  }),
};
/** Details Page Actions ***/
